"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealProcessor = void 0;
const logic_types_1 = require("./logic-types");
class DealProcessor {
    constructor(board, dealer, cardIndexMapping) {
        this.board = board;
        this.dealer = dealer;
        this.cardIndexMapping = cardIndexMapping;
    }
    disclosePendingCards(commandHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const allCards = this.board.cardsInPlay();
            const cardIndexes = allCards
                .filter((card) => this.cardIndexMapping.setStatusWhenPendingForIndex(card.index, logic_types_1.CardDisclosureStatus.InProgress))
                .map((card) => card.index);
            if (cardIndexes.length === 0) {
                return;
            }
            yield this.askDealerForCardIds(cardIndexes, commandHash);
        });
    }
    askDealerForCardPeek(index, hash) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.processDealerRequest([index], hash, true));
        });
    }
    askDealerForCardIds(indexes, hash) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.processDealerRequest(indexes, hash, false);
        });
    }
    processDealerRequest(indexes, hash, isPeek) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: why it returns void?
            const ids = yield this.dealer.discloseSecrets(indexes, hash);
            if (isPeek) {
                this.cardIndexMapping.peekDeck(indexes[0]);
            }
            else {
                this.cardIndexMapping.dealDeck(indexes, ids);
            }
            if (isPeek) {
                if (ids.length === 1) {
                    const num = Number(ids[0]);
                    return !isNaN(num) && num === 1;
                }
                return false;
            }
        });
    }
}
exports.DealProcessor = DealProcessor;
